// extracted by mini-css-extract-plugin
module.exports = {"container":"BattlesPage_container__1jJAh","title":"BattlesPage_title__2fufG"};